import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})
export class CommentComponent implements AfterViewInit {
  @Input() placeholder: string = 'Add a comment...';

  @Output() closePanelEmitter:EventEmitter<boolean>= new EventEmitter<boolean>();
  @Output() onCommentEmitter:EventEmitter<any>= new EventEmitter<any>(); 
   
  comment:string = '';
  constructor() { }

    onKeyUp(e: any){
    this.comment = e.target.value;
  }

  onDismiss(){
    this.closePanelEmitter.emit(true);
    this.comment = '';  
  }

  onSubmit(){
  this.onCommentEmitter.emit({comment: this.comment});
   this.comment = '';
 }

 ngAfterViewInit(): void {
    this.comment = '';
  }

}
